export const url = `https://r6knd0l9s8.execute-api.us-east-1.amazonaws.com/${process.env.BACKEND_API_STAGE}`;
